module.exports = __webpack_public_path__ + "img/Gugel.8badd1fb.png";